import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'app-prices',
    templateUrl: './prices.html'
  })
  export class PricesComponent implements OnInit {
    ngOnInit(): void {
    }
  }